// Load pdfMake and fonts correctly
const pdfMake = require('pdfmake/build/pdfmake');
const pdfFonts = require('pdfmake/build/vfs_fonts');

// Attach virtual font system
pdfMake.vfs = pdfFonts.vfs;

// Make available globally if needed
global.pdfMake = pdfMake;

// Optionally load axios if you need it globally
global.axios = require('axios');
